import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as AlertTriangleIcon } from '../../../assets/alert-triangle.svg';
import { formatDateShort } from "../../../functions/misc";

export interface ItemModalProps {
    onClose: () => void,
    notice: any,
    open: boolean;
  }
  
  export function NoticeDisplayModal({ onClose, notice, open = false }: ItemModalProps): React.JSX.Element {
      
    return (
        <Dialog open={open} sx={{justifyContent: 'center'}} maxWidth={'xs'}>
          <DialogContent sx={{mt: 3}}>
              <Box sx={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                  <AlertTriangleIcon height={30} width={30}/>
                  <Typography variant="h5" sx={{textAlign: 'center', mt: 2, textTransform: 'uppercase'}}>
                  {notice.NoticeIssued}
                  </Typography>
                  <Typography variant="body2" sx={{textAlign: 'center', mt: 2, color: '#667085'}}>
                  {`Issue Date: ${formatDateShort(notice.Date)}`}
                  </Typography>
                  <Typography variant="body2"  sx={{textAlign: 'left', mt: 2}}>
                  {notice.NoticeDescription}
                  </Typography>
                  <Box sx={{mt:3}}>
                    <Button className="option-primary-button" onClick={onClose}>CLOSE</Button>
                  </Box>
              </Box>
          </DialogContent>
        </Dialog>
      )
    
  }